import { Col, Divider, Row } from "antd";
import React from "react";
import { CustomInput } from "../../Components/CustomInput/Input";
import { CustomLabel } from "../../Constant";

const InputFormComponentBelstar = ({ label, msg, error = false, ...props }) => {
    return (
        <div className={"cls_mghunt8j_397fc0"}>
            <Row>
                {/* <CustomLabel>
                    {label} <span className={"cls_mghunt8k_02f323"}>*</span>
                </CustomLabel> */}
                <CustomInput error={error} {...props} style={{ width: "100%" }} />
                {error && (
                    <div className={"cls_mghunt8k_5e2ded"}>
                        {" "}
                        <label className={"cls_mghunt8k_56de7a"}>{msg}</label>
                    </div>
                )}
                <Divider />
            </Row>
        </div>
    );
};

export default InputFormComponentBelstar;
